"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadScript = void 0;
/**
 * Load a script.
 *
 * We can use promises because we have the promise
 * polyfill loaded.
 *
 * @param src
 */
var loadScript = function (src) { return new Promise(function (resolve, reject) {
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = !0;
    s.onerror = function (err) {
        if (err instanceof ErrorEvent) {
            return reject(new Error('Failed to load script: ' + src + '. Message: ' + err.message + '.'));
        }
        reject(new Error('Failed to load script: ' + src + '.'));
    };
    s.onload = function () {
        resolve();
    };
    // You should set the src attribute after the onload event
    s.src = src;
    document.head.appendChild(s);
}); };
exports.loadScript = loadScript;
